const formatGameItemDate = (date) => {
  const dateString = new Date(date).toLocaleDateString('en-us', {
    month: 'short',
    day: 'numeric',
  });
  const timeString = new Date(date).toLocaleTimeString('en-us', {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  });

  return `${dateString} - ${timeString}`;
};

export { formatGameItemDate };
